import { render } from "./Alert.vue?vue&type=template&id=1371c6f3&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=1371c6f3&scoped=true&lang=css"
import "@/styles/header.css?vue&type=style&index=1&id=1371c6f3&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=1371c6f3&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=3&id=1371c6f3&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1371c6f3"]])

export default __exports__